
































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import RouteTranslations from "@/locales/routerTranslations";
import {UtilitiesRequests} from "@/helpers";

@Component
export default class LanguageManager extends Vue {
  languages: Array<string> = ["it", "en"];
  currentLang: string = "";
  translations: any = RouteTranslations;

  @Prop({default: ""}) private imageWidth!: string;

  @Watch("currentLang", {immediate: true, deep: true})
  onLangChanged(val: string) {
    // console.warn("do something on language change");
  }

  mounted() {
    this.currentLang = this.$i18n.locale;
  }

  handleLang(lang: string) {
    this.$i18n.locale = lang;
    this.currentLang = lang;
    let toRoute: string = "";
    let queryParams: string = "";
    if (this.$route.name && this.currentLang) {
      toRoute = this.translations[this.currentLang][this.$route.name].link;
    }
    this.storeTags().then(() => {
      if (this.$route.params.id) {
        this.$router.push({path: `${toRoute}/${this.$route.params.id}`, query: this.$route.query});
      } else {
        this.$router.push({path: toRoute, query: this.$route.query});
      }
    });
  }

  getFlag(lang: string) {
    return require(`../assets/icons/${lang}.png`);
  }

  storeTags() {
    return UtilitiesRequests.getAllTags()
      .then((response: any) => {
        this.$store.dispatch("app/setTagsList", response);
      })
      .catch((error: any) => {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
      });
  }
}
